<template>
  <div class="right-content">
    <Header />
    <div class="content">
       <a-config-provider :locale="locale">
        <router-view />
      </a-config-provider>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header.vue";
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  components: {
    Header
  },
  data() {
      return {
        locale: zhCN,
      };
  },
};
</script>

<style lang="less" scoped>
.right-content {
  background-color: #fff;
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow-x: hidden;
  .content {
    flex: 1;
    box-sizing: border-box;
    overflow-y: scroll;
  }
}
</style>
